import { UserPlusIcon } from '@heroicons/react/20/solid';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../EmptyFragment';
import { GroupResource } from '../../../../../GroupsStore/Types';
import { findLink } from '../../../../../LinkyLinky';
import { MulticheckStore } from '../../../../../Multicheck/Store';
import { Link } from '../../../../../Resource/Types';
import { T } from '../../../../../Translations';

interface Props {
  multicheckStore: MulticheckStore<GroupResource>;
  links: ReadonlyArray<Link>;
  loading: (link: Link, multicheckStore: MulticheckStore<GroupResource>) => void;
}

function OpenModalButton({ loading, links, multicheckStore }: Props) {
  return findLink('bulk-provision-license', links)
    .map((link) => (
      <button
        className="flex rounded-md border-[1px] items-center border-solid border-teal-600 px-5 py-2 text-teal-600"
        onClick={() => loading(link, multicheckStore)}
      >
        <span className="mr-2">
          <UserPlusIcon height="30px" />
        </span>
        <T kind="Allocate License to Group Members" />
      </button>
    ))
    .getOrElse(emptyFragment);
}

export default observer(OpenModalButton);
